import { render, staticRenderFns } from "./PopularityList.vue?vue&type=template&id=1f4cf466&"
import script from "./PopularityList.vue?vue&type=script&lang=js&"
export * from "./PopularityList.vue?vue&type=script&lang=js&"
import style0 from "./PopularityList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports